export const routes = (parentName) => {
  return [
    {
      path: "company",
      component: () => import("./Index.vue"),

      children: [
        {
          path: "checking",
          name: `${parentName}-Company-Checking`,
          component: () => import("./List.vue"),
        },
        {
          path: "active",
          name: `${parentName}-Company-Active`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "deactive",
          name: `${parentName}-Company-Deactive`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Company-Edit",
          component: () => import("./Upsert.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: ":id",
          name: parentName + "-" + "Company-View",
          component: () => import("./View.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
      ],
    },
  ];
};
